export const FrameText = ({
	text,
	fontWeight,
	fontSize,
	textColor,
	textY,
	xOffset = 0,
	rotation,
	fontFamily,
	textLength,
}: {
	text: string
	fontWeight?: string
	fontSize: number
	textColor: string
	textY: number
	xOffset?: number
	rotation?: number
	fontFamily: string
	textLength?: number
}) => (
	<text
		x={32 + xOffset}
		y={textY}
		textAnchor="middle"
		dominantBaseline="middle"
		fontSize={fontSize}
		fontWeight={fontWeight || '700'}
		fontFamily={fontFamily}
		fill={textColor}
		transform={
			rotation
				? `rotate(-${rotation} ${(32 + xOffset) / 2} ${textY})`
				: undefined
		}
		textLength={textLength}
		lengthAdjust={textLength ? 'spacingAndGlyphs' : undefined}
	>
		{text}
	</text>
)
